'use client';

import { useEffect } from 'react';
import { usePreferencesStore } from '@/stores/preferences-store';

const FONT_SCALE: Record<string, string> = {
  sm: '0.9',
  md: '1',
  lg: '1.1',
};

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = usePreferencesStore((s) => s.theme);
  const fontSize = usePreferencesStore((s) => s.fontSize);

  // Apply theme
  useEffect(() => {
    const root = document.documentElement;
    let actual: 'light' | 'dark';
    if (theme === 'system') {
      actual = window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    } else {
      actual = theme;
    }
    root.classList.toggle('dark', actual === 'dark');
    root.style.colorScheme = actual;

    if (theme === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const handler = (e: MediaQueryListEvent) => {
        root.classList.toggle('dark', e.matches);
        root.style.colorScheme = e.matches ? 'dark' : 'light';
      };
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }
  }, [theme]);

  // Apply font scale
  useEffect(() => {
    document.documentElement.style.setProperty('--font-scale', FONT_SCALE[fontSize] || '1');
  }, [fontSize]);

  return <>{children}</>;
}
